export default function Error({ errorMessage }) {
  return (
    <div className="container">
      <div className="col-12">
        Something went wrong. {navigator.onLine ? errorMessage : 'You\'re offline'}
      </div>
    </div>
  );
}
